module.exports = __webpack_public_path__ + "img/icon_lottery.11d4b3d4.png";